import React from 'react';
import Grid from 'atoms/Layout/Grid/Grid';
import SenjaReviews from './SenjaReviews';
import Button, { ButtonProps } from 'atoms/Button/Button';
import Stack from 'atoms/Layout/Stack/Stack';
import HeadingAndSupportingTextWithActions, {
  HeadingAndSupportingTextWithActionsProps,
} from 'molecules/HeadingAndSupportingText/HeadingAndSupportingTextWithActions';

interface SenjaReviewsWithTextBlockProps {
  heading: HeadingAndSupportingTextWithActionsProps['heading'];
  supportingText: HeadingAndSupportingTextWithActionsProps['supportingText'];
  button?: ButtonProps;
  senjaId: string;
}

const SenjaReviewsWithTextBlock = ({
  heading,
  supportingText,
  button,
  senjaId,
}: SenjaReviewsWithTextBlockProps): JSX.Element => {
  return (
    <Stack
      justify='center'
      align='center'
      direction='column'
      gap='spacing-7xl'
      gapSm='spacing-4xl'
    >
      <Grid>
        <HeadingAndSupportingTextWithActions
          heading={heading}
          supportingText={supportingText}
          direction='row'
          actions={
            button && (
              <Stack hideOn='lg'>
                <Button {...button}>{button.children}</Button>
              </Stack>
            )
          }
        />
      </Grid>
      <SenjaReviews senjaId={senjaId} />
      <Stack
        showOn='lg'
        maxWidth='width-xxs'
        maxWidthSm='width-xs'
      >
        <Button {...button}>{button.children}</Button>
      </Stack>
    </Stack>
  );
};

export default SenjaReviewsWithTextBlock;
